/* eslint-disable no-shadow */

import React from 'react';
import classnames from 'classnames';
import { useDispatch } from 'react-redux';

import { setActiveDrawer } from '../../actions/lister-actions';
import TRANSLATIONS from '../../translations/translations@default.json';

export const Refine = ({ sticky, customCatsEnabled }) => {
	const dispatch = useDispatch();

	return (
		<div className="w-full pl-px">
			<button
				type="button"
				onClick={() => dispatch(setActiveDrawer('refineFacets'))}
				className={classnames('cta btn btn-primary flex justify-start w-full h-12 rounded-none', {
          'rounded-r': sticky && customCatsEnabled,
          'justify-center': customCatsEnabled
        })}
				data-tag-name="refine-search">
				<i className="ico ico-menu ico-2x mr-3 -mt-px text-lg text-lightgreen" />
				{TRANSLATIONS.controls.filters.filtersButton}
			</button>
		</div>
	);
};

export default Refine;
